var CONFUSEDWEBSITE = CONFUSEDWEBSITE || {},
    CSSCONSTANTS = CSSCONSTANTS || {};

(function ($) {

	CONFUSEDWEBSITE.expandingPanel = function () {
	    var $expandingPanels = $('.' + CSSCONSTANTS.expandingPanelClass);

	    $.each($expandingPanels, function () {
	        var $this = $(this),
                $panelHeading = $this.find('.' + CSSCONSTANTS.expandingPanelHeadingClass),
                $panelHeadingLink = $panelHeading.find('.' + CSSCONSTANTS.expandingPanelHeadingLinkClass),
	            $panelContent = $this.find('.' + CSSCONSTANTS.expandingPanelContentClass);

	        if ($panelHeading.hasClass(CSSCONSTANTS.expandingPanelHeadingClosedClass)) {
                $panelContent.hide();
	        }

	        $panelHeadingLink.click(function (e) {
	            e.preventDefault();
	            if ($panelHeading.hasClass(CSSCONSTANTS.expandingPanelHeadingOpenClass)) {
	                $panelHeading.removeClass(CSSCONSTANTS.expandingPanelHeadingOpenClass).addClass(CSSCONSTANTS.expandingPanelHeadingClosedClass);
	            }
	            else {
	                $panelHeading.removeClass(CSSCONSTANTS.expandingPanelHeadingClosedClass).addClass(CSSCONSTANTS.expandingPanelHeadingOpenClass);
	            }
	            $panelContent.slideToggle('fast');
	        });
	    });

	};

})(window.jQuery);